// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as CatalogLabel from "./CatalogLabel.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantMutations from "./CatalogVariantMutations.res.js";
import * as CatalogVariantArchiveModal from "./CatalogVariantArchiveModal.res.js";
import * as CatalogLabelQuickPrintButton from "./CatalogLabelQuickPrintButton.res.js";

function CatalogVariantPageActions(props) {
  let variant = props.variant;
  let cku = props.cku;
  let match = Navigation.useUrl();
  let match$1 = React.useState(() => false);
  let setArchiveModalOpened = match$1[1];
  let match$2 = React.useState(() => {});
  let setPrinterStatusResult = match$2[1];
  let printerStatusResult = match$2[0];
  let unarchiveVariant = CatalogVariantMutations.useUnarchive(variant.id);
  let activateVariant = CatalogVariantMutations.useActivate(variant.id);
  let deactivateVariant = CatalogVariantMutations.useDeactivate(variant.id);
  let activeShop = Auth.useActiveShop();
  let scope = Auth.useScope();
  let disabledKeysMenuActions = Stdlib_Option.isNone(activeShop) ? [
      "archive",
      "activate",
      "deactivate"
    ] : [];
  let tooltipTextMenuActionsItem = Stdlib_Option.isNone(activeShop) ? I18n.t("Please select a shop beforehand.") : undefined;
  React.useEffect(() => {
    if (activeShop === undefined) {
      return;
    }
    let future = CatalogLabel.Print.DefaultPrinterRequest.make(activeShop.id);
    Future.map(future, undefined, result => setPrinterStatusResult(param => result));
    return () => Future.cancel(future);
  }, [activeShop]);
  let tmp;
  let exit = 0;
  if (printerStatusResult !== undefined) {
    let exit$1 = 0;
    let status;
    if (printerStatusResult.TAG === "Ok" || printerStatusResult._0 === "NoPrinterFound") {
      status = printerStatusResult;
      exit$1 = 2;
    } else {
      tmp = null;
    }
    if (exit$1 === 2) {
      if (activeShop !== undefined) {
        tmp = JsxRuntime.jsx(CatalogLabelQuickPrintButton.make, {
          variation: {
            NAME: "button",
            VAL: {
              featureLocked: Stdlib_Result.isError(status)
            }
          },
          fromEditRedirection: props.fromLabelEditSettingsRedirected,
          variantId: variant.id,
          shopId: activeShop.id,
          requestBarcodeCompletion: CatalogLabel.BarcodeCompletionRequest.make,
          requestLabelsPrinting: CatalogLabel.Print.LabelsRequest.make,
          onRequestNotification: props.onRequestNotification
        });
      } else {
        exit = 1;
      }
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Print label"),
        disabled: true,
        icon: "legacy_printer"
      }),
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: I18n.t("Please select a shop beforehand.")
      }),
      disabled: Stdlib_Option.isSome(activeShop),
      delay: 350
    });
  }
  let match$3 = variant.status;
  let tmp$1;
  let exit$2 = 0;
  if (typeof match$3 === "object") {
    let exit$3 = 0;
    if (scope.TAG === "Organisation" && scope.activeShop === undefined) {
      exit$2 = 1;
    } else {
      exit$3 = 2;
    }
    if (exit$3 === 2) {
      tmp$1 = JsxRuntime.jsx(Button.make, {
        label: I18n.t("Unarchive"),
        tone: "brand",
        icon: "unarchive",
        onPress: () => {
          unarchiveVariant();
        }
      });
    }
  } else {
    exit$2 = 1;
  }
  if (exit$2 === 1) {
    let tmp$2;
    tmp$2 = scope.TAG === "Organisation" ? JsxRuntime.jsx(MenuActions.Item.make, {
        title: I18n.t("Duplicate"),
        href: CatalogRoutes.variantDuplicationRoute(cku),
        icon: "duplicate_v2"
      }) : null;
    let match$4 = variant.status;
    let tmp$3;
    if (match$4 !== undefined) {
      let exit$4 = 0;
      if (typeof match$4 !== "object") {
        switch (match$4) {
          case "Inactive" :
            tmp$3 = JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Mark as on sale"),
              icon: "product_ok",
              tooltipText: tooltipTextMenuActionsItem,
              onAction: () => {
                activateVariant();
              }
            }, "activate");
            break;
          case "Active" :
          case "Unarchived" :
            exit$4 = 2;
            break;
        }
      } else {
        tmp$3 = null;
      }
      if (exit$4 === 2) {
        tmp$3 = JsxRuntime.jsx(MenuActions.Item.make, {
          title: I18n.t("Remove from sale"),
          icon: "product_nok",
          tooltipText: tooltipTextMenuActionsItem,
          onAction: () => {
            deactivateVariant();
          }
        }, "deactivate");
      }
    } else {
      tmp$3 = null;
    }
    tmp$1 = JsxRuntime.jsxs(MenuActions.make, {
      children: [
        JsxRuntime.jsxs(MenuActions.Section.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Edit"),
              href: match.pathname + `/edit`,
              icon: "edit"
            }),
            tmp$2
          ]
        }),
        JsxRuntime.jsxs(MenuActions.Section.make, {
          children: [
            tmp$3,
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Archive"),
              tone: "danger",
              icon: "archive",
              tooltipText: tooltipTextMenuActionsItem,
              onAction: () => setArchiveModalOpened(param => true)
            }, "archive")
          ]
        })
      ],
      trigger: {
        TAG: "Normal",
        label: I18n.t("Actions")
      },
      disabledKeys: disabledKeysMenuActions
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsxs(Inline.make, {
        children: [
          tmp,
          JsxRuntime.jsx(Button.make, {
            label: I18n.t("See bound product"),
            icon: "variant_see",
            href: CatalogRoutes.productRedirectRoute(cku)
          }),
          tmp$1
        ],
        space: "small"
      }),
      JsxRuntime.jsx(CatalogVariantArchiveModal.make, {
        id: variant.id,
        opened: match$1[0],
        onRequestClose: () => setArchiveModalOpened(param => false)
      })
    ]
  });
}

let make = React.memo(CatalogVariantPageActions);

let Config;

export {
  Config,
  make,
}
/* make Not a pure module */
